import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'

new factory.IAInit()
openMobileSubmenu()

const $ = factory.$


$(document).ready(function () {
    var header = $('.section-header');
    // Menu mobile
    $(document).on('click', '.ia-block-navigation__toggle input[type="checkbox"]', function(event) {
        var $toggle = $(this).parent();
        var $content = $toggle.next('.ia-block-navigation__content');

        if ($(this).prop('checked')) {
            $('html').addClass('no-scroll');
            $content.after('<div class="ia-block-navigation__outer"></div>');
            $content.addClass('is-open');
        } else {
            $('html').removeClass('no-scroll');
            $content.removeClass('is-open');
            $('.ia-block-navigation__outer').remove();
        }
    });

    $(document).on('click', '.ia-block-navigation__outer', function(event) {
        var $toggle = $(this).parent().find('.ia-block-navigation__toggle');
        $toggle.find('input[type="checkbox"]').click();
    });

    $(document).on('click', '.footer .menu-item-has-children', function(){
        if ($(this).find('.sub-menu').hasClass('is-active')){
            $('.footer .menu-item-has-children .sub-menu').slideUp().removeClass('is-active');
        }else {
            $(this).find('.sub-menu').slideDown().addClass('is-active');
        }
    })
    $(document).on('click', '[data-toggle]:not([data-toggle="#mainmenu"])', function (event) {
        var targets = $(this).attr('data-toggle');
        var $this = $(this);

        if (targets.indexOf(' ') !== -1) {
            targets = targets.split(' ');
        } else {
            targets = [];
            targets.push($this.attr('data-toggle'));
        }

        targets.forEach(function (target) {
            if (target !== '' && $(target).length) {
                collapseToggle(target, $(this).attr('data-scroll') === 'off' ? true : false);
                setTimeout(function () {
                    if ($(target).hasClass('is-shown')) {
                        $(target).find('input[type="text"]').first().trigger('focus');
                    }
                }, 300);
            }
        });
    });
    //INIT SLIDERS
    initSliders();

    $(document).on('click', '.section-default a[href^="#"]:not([href="#"])', function(event) {
        event.preventDefault();
        var $target = $($(this).attr('href'));
        if($(this).attr('id') == 'scrollTopPage'){
            $('body, html').animate({
                scrollTop: 0
            }, 600);
        }else{
            $('body, html').animate({
                scrollTop: $target.offset().top - header.height()*1.5
            }, 400);
        }
      });

    if($('.ia-list-rentals__filter-item-label').length){
        $(document).on('click', '.ia-list-rentals__filter-item-label, .ia-list-rentals__filter-item a', function(){
            checkCat($(this));
        })
    }

    $(document).on('click', '.ia-block-navigation__list > .menu-item-has-children', function(){
        if(isMobile()){
            $(this).find('.sub-menu').toggleClass('is-active');
        }
    })
});


function collapseToggle(target, scrollOff) {
    if ($(target).length) {
        $(target).toggleClass('is-shown');
        setTimeout(function () {
            if ($(target).hasClass('is-shown')) {
                $(target).slideDown('fast');
            } else {
                $(target).slideUp('fast');
            }
        }, 100);

        if (scrollOff) {
            setTimeout(function () {
                $('body').toggleClass('no-scroll');
            }, 400);
        } else {
            $('body').removeClass('no-scroll');
        }
    }
}

function checkCat(input) {
    var checkboxList = input.parent().parent();
    var checkedElem = [];
    var listItems = $('.ia-slider-rentals__item');

    if(input.find('#all').length || input.attr('href') == "#reset") {
        checkboxList.find('input').prop('checked', false);
        checkboxList.find('#all').prop('checked', true);
    } else {
        checkboxList.find('#all').prop('checked', false);
    }

    if(checkboxList.find('#all').prop('checked') || input.attr('href') == "#reset"){
        listItems.each(function(){
            $(this).show();
        })
    }else {
        checkboxList.children().each(function(){
            if($(this).find('input').is(':checked')){
                checkedElem.push($(this).find('input').attr('data-filter-rental'));
            }else {
                var index = checkedElem.indexOf($(this).find('input').attr('data-filter-rental'));
                if (index > -1) {
                    checkedElem.splice(index, 1);
                }
            }
        })
        listItems.each(function(){
            if(checkedElem.includes($(this).attr('data-rental'))){
                $(this).show();
            }else{
                $(this).hide();
            }
        })
    }
    
}


function initSliders() {
    if($('.ia-slider-rentals').length){
        var elemRent = $('.ia-slider-rentals .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 50,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 2.5,
                }
            } ,
            navigation: {
                nextEl: $('.ia-slider-rentals').find('.swiper-button-next'),
                prevEl: $('.ia-slider-rentals').find('.swiper-button-prev')
            }
        });
    }
    if($('.ia-slider-actus').length){
        var elemRent = $('.ia-slider-actus .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 50,
            autoHeight: true,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 2.5,
                }
            } ,
            navigation: {
                nextEl: $('.ia-slider-actus').find('.swiper-button-next'),
                prevEl: $('.ia-slider-actus').find('.swiper-button-prev')
            }
        });
    }
    if($('.ia-slider-partners').length){
        var elemRent = $('.ia-slider-partners .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 50,
            centerInsufficientSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 4,
                }
            },
            navigation: {
                nextEl: $('.ia-slider-partners').find('.swiper-button-next'),
                prevEl: $('.ia-slider-partners').find('.swiper-button-prev')
            } 
        });
    }
    if($('.ia-slider-related-projects').length){
        var elemRent = $('.ia-slider-related-projects .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 50,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 2.5,
                }
            } ,
            navigation: {
                nextEl: $('.ia-slider-related-projects').find('.swiper-button-next'),
                prevEl: $('.ia-slider-related-projects').find('.swiper-button-prev')
            }
        });
    }
    if($('.ia-timeline').length){
        var elemRent = $('.ia-timeline .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 4,
                }
            } ,
            navigation: {
                nextEl: $('.ia-timeline').find('.swiper-button-next'),
                prevEl: $('.ia-timeline').find('.swiper-button-prev')
            }
        });
    }
    if($('.ia-timeline').length){
        var elemRent = $('.ia-timeline .swiper-container')[0];
        if(elemRent.swiper != '' && elemRent.swiper != undefined) {
            elemRent.swiper.destroy();
        }
        var slider = new Swiper(elemRent, { 
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView : 2,
                },
                1024: {
                    slidesPerView : 4,
                }
            } ,
            navigation: {
                nextEl: $('.ia-timeline').find('.swiper-button-next'),
                prevEl: $('.ia-timeline').find('.swiper-button-prev')
            }
        });
    }
    $('.js-newslist').each(function(i, el) {
        var $list = $(el);
        var postPerPage = parseInt($list.attr('data-item-load'));
        var allPostShown = false;

        $(document).on('click', '.js-newslist-loadmore', function(event) {
            var firstHidden = $(this).parent().prev('.js-newslist').find('.js-newslist-item[style="display: none;"]')[0];
            setTimeout(function() {
                $(firstHidden).find('a')[0].focus();
            }, 200);


            var idx = 0;
            $list.find('.js-newslist-item[style="display: none;"]').each(function(j, item) {
                if (idx < postPerPage) {
                    $(item).fadeIn();
                }
                idx++;
            });

            if ($list.find('.js-newslist-item[style="display: none;"]').length == 0) {
                $list.next('.js-newslist-pagination').fadeOut();
            }
        });
    });
}
document.querySelectorAll('.ia-blocks-form').forEach(form => {
    new factory.IAForm(
        form,
        {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }
    ).formInside(false)
})

function isMobile() {
    let isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
    return isMobile;
}

document.querySelectorAll('a > .open-menu-btn').forEach(element => {
    const linkToReplace = element.parentElement
    var button = document.createElement('button')
    button.innerHTML = linkToReplace.innerHTML
    button.setAttribute('aria-expanded', 'false')
    button.setAttribute('class', 'open-menu-btn')
    button.querySelector('.open-menu-btn').remove()
    linkToReplace.parentNode.replaceChild(button, linkToReplace)

    const subMenu = button.parentNode.querySelector('.sub-menu')
        if (subMenu) {
        button.addEventListener('click', function() {
            const isExpanded = button.getAttribute('aria-expanded') === 'true'
            button.setAttribute('aria-expanded', !isExpanded)
            subMenu.style.display = isExpanded ? 'none' : 'block'
        });
    }
});